export { default } from './Pagination';
export { default as usePagination } from './usePagination';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/Pagination/index.js
// module id = 371
// module chunks = 0